import classNames from 'classnames'

export const fadeInFadeOutTw = (isOpen: boolean) => {
  return classNames('transition-all duration-300', {
    'opacity-100 visible': isOpen,
    'opacity-0 invisible': !isOpen,
  })
}

export const fadeInFadeOutLargeTw = (isOpen: boolean) => {
  return classNames('transition-all duration-300', {
    'opacity-100 visible': isOpen,
    'opacity-0 invisible': !isOpen,
  })
}
